import classNames from 'classnames';
import { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { MastercardSVG } from '../../../svgComponents/mastercardSVG';
import { TickCircleSVG } from '../../../svgComponents/tickCircleSVG';
import { VisaSVG } from '../../../svgComponents/visaSVG';
import { EDIT_DEBIT_CARD } from '../../modals/editPaymentMethodModal/EditPaymentMethodModal.actions';
import messages from './PaymentCard.messages';
import { getCountry } from '../../../iwIntlProvider/CountryProvider';
import { Text } from '@ui';

const mapDispatchToProps = (dispatch) => ({
    editDebitCard: (id) => {
        dispatch({
            type: EDIT_DEBIT_CARD,
            paymentMethodID: id
        });
    }
});

export class PaymentCard extends Component {
    renderBrandIcon() {
        const { brand } = this.props;

        switch (brand) {
            case 'visa':
                return <VisaSVG className="h-auto max-w-[50px]" />;
            case 'mastercard':
                return <MastercardSVG className="h-auto max-w-[50px]" />;
            default:
                return null;
        }
    }

    renderRepaymentLabel() {
        const { isPrimary, isWithStripe } = this.props;

        let message;
        if (getCountry() === 'DE' && isWithStripe) {
            message = <FormattedMessage {...messages.directDebit} />;
        } else if (isPrimary) {
            message = <FormattedMessage {...messages.automaticRepayment} />;
        }

        return message ? (
            <div className="flex items-center">
                {isPrimary && <TickCircleSVG />}
                <Text className="ml-s text-s font-med">{message}</Text>
            </div>
        ) : null;
    }

    renderEditLabel() {
        const { paymentMethodID, isWithStripe } = this.props;

        // Can't edit direct debit details for DE
        if (getCountry() === 'DE' && isWithStripe) return null;

        return (
            <button
                className="ml-auto border-none bg-transparent underline hover:cursor-pointer"
                onClick={() => this.props.editDebitCard(paymentMethodID)}
            >
                <FormattedMessage {...messages.edit} />
            </button>
        );
    }

    render() {
        const { cardNumber, brand } = this.props;

        const brandStyles = {
            visa: 'bg-[#00afdf]',
            mastercard: 'bg-[#252525]'
        };

        return (
            <div
                className="h-fit rounded-s bg-structure-100 shadow-black-s"
                data-testid="repayment-card"
            >
                <div
                    className={classNames(
                        'flex min-h-[90px] items-end justify-between rounded-t-s p-l',
                        brandStyles[brand]
                    )}
                >
                    <Text className="text-s font-reg text-structure-100">
                        {`●●●● ${cardNumber?.slice(cardNumber?.length - 4)}`}
                    </Text>
                    {this.renderBrandIcon()}
                </div>
                <div className="flex justify-between px-l py-s">
                    {this.renderRepaymentLabel()}
                    {this.renderEditLabel()}
                </div>
            </div>
        );
    }
}

// eslint-disable-next-line import/no-default-export
export default connect(null, mapDispatchToProps)(PaymentCard);
